import type { CssVarsTheme } from '@mui/material';
import type { Components } from '@mui/material/styles';

const overrides: NonNullable<
  Components<CssVarsTheme>['MuiListItem']
>['styleOverrides'] = {
  root: () => ({
    'a .MuiListItemButton-root': {
      color: 'inherit',
      fontWeight: 500,
      textDecoration: 'none',
    },
  }),
};

const styleOverrides: Pick<Components<CssVarsTheme>['MuiListItem'], never> = {
  styleOverrides: overrides,
};

export default styleOverrides;
